import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=3e94111a&"
import script from "./Feature.vue?vue&type=script&lang=ts&"
export * from "./Feature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports